<template>
  <div class="scene-box">
    <banner-control></banner-control>
    <div v-if="!isMobile" class="lists">
      <div id="section1" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >01<img src="@/static/images/text-line-1.png" /></span
                  ><span>批量校招考试</span>
                </div>
                <div class="font-14">
                  <ul>
                    <li>
                      无时间、地点、空间限制，轻松组织全球海量考生统考，快速淘劣；
                    </li>
                    <li>
                      招聘会现场，手机扫一扫随时随地开启一场考试，秒出成绩报告；
                    </li>
                    <li>
                      邮件、短信等触达考生的通道到达率高，实时监看考试确认参加情况，保障到场率；
                    </li>
                    <li>
                      分布式可无限弹性扩充系统，保证十万人同时在线考试，安全稳定，超强并发。
                    </li>
                  </ul>
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-1-map.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section2" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-2-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >02<img src="@/static/images/text-line-2.png" /></span
                  ><span>企业社招考试</span>
                </div>
                <div class="font-14">
                  轻松发布笔试试卷，多种方式通知候选人，支持PC、手机端参加笔试答题；<br />
                  HR将候选人的试卷报告链接分享给负责人评阅试卷，快速收集笔试结果；<br />
                  友好的阅卷界面、一键评分，填写评语，自动保存评分结果；<br />
                  HR实时查看笔试成绩和评语，优化招聘全流程，快速锁定优秀人才。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section3" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >03<img src="@/static/images/text-line-1.png" /></span
                  ><span>员工晋升考核</span>
                </div>
                <div class="font-14">
                  低成本高效率完成内部员工晋升、胜任力达标能力测试、素质测评；<br />
                  无纸化考试，无需打印试卷、安排地点，节约线下内部考核成本；<br />
                  统计分析考核结果，掌握员工作答情况；<br />
                  随时按需组织考试，让员工晋升考核更简单、有效。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-3-map.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section4" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-4-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >04<img src="@/static/images/text-line-2.png" /></span
                  ><span>培训认证考核</span>
                </div>
                <div class="font-14">
                  批量上传、随机组卷、智能阅卷、智能分析等功能从多方面为前期组织考试节省大量的成本；<br />
                  考前人脸身份核验，权威数据确保本人考试；<br />
                  智能判分系统，考后直出成绩及排行榜等信息；<br />
                  对严肃正式的证书认证考试场景给予专业的技术支持，确保线上考试的公平、公正，促进人员甄别的速率提升
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section5" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >05<img src="@/static/images/text-line-1.png" /></span
                  ><span>高校招生测评</span>
                </div>
                <div class="font-14">
                  学校招生统一专业能力考试，更稳定、更安全；<br />
                  基于AI的智能在线监考技术，通过音频+视频的方式对考试过程进行全面监控，保证线上考试的信效度；<br />
                  远程视频面试选拔，面试流畅无卡顿；<br />
                  已经获得国家信息系统安全等级保护三级认证，确保面试数据安全。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect5"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-5-map.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section6" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 260px; left: 120px; height: inherit"
                  src="@/static/images/sence-6-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >06<img src="@/static/images/text-line-2.png" /></span
                  ><span>随堂练习检测</span>
                </div>
                <div class="font-14">
                  学生随堂参加测试，考后查看题目解析，提升能力；<br />
                  固定试题、随机试题、灵活的组卷方式；<br />
                  大批量试题快速导入，音视频批量上传，更高效率；<br />
                  可与学校管理系统对接，实现考试数据同步更新。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section7" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >07<img src="@/static/images/text-line-1.png" /></span
                  ><span>专业知识竞赛</span>
                </div>
                <div class="font-14">
                  提供专业知识竞赛平台，比赛页面专属定制化；<br />
                  内置报名、组队、闯关等功能 ；<br />
                  支持自动化判分，排名，支持数据、模型可视化；<br />
                  支持在线编码，运行生成模型结果。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect5"
                  style="width: 360px; left: 60px; height: inherit"
                  src="@/static/images/sence-7-map.png"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section8" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  src="@/static/images/sence-8-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left" style="margin-left: 160px">
              <div class="product-desc cn">
                <div class="product-desc__title">
                  <span class="num"
                    >08<img src="@/static/images/text-line-2.png" /></span
                  ><span>海量题库刷题</span>
                </div>
                <div class="font-14">
                  为用户提供全面的技能提升练习平台；<br />
                  碎片化时间，记录你的学习足迹，让进步看的见；<br />
                  学员按知识点分类刷题，随机抽题，进阶学习；<br />
                  十万专业题目，支持10大题型，海量题库使用。
                </div>
                <a @click="goTest" class="btn" href="javascript:void(0)"
                  >产品试用</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isMobile" class="exam-mobile-lists">
      <div id="section1" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-1-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >01<img src="@/static/images/text-line-1.png" /></span
                  ><span>批量校招考试</span>
                </div>
                <div class="font-14">
                  <ul>
                    无时间、地点、空间限制，轻松组织全球海量考生统考，快速淘劣；
                    招聘会现场，手机扫一扫随时随地开启一场考试，秒出成绩报告；
                    邮件、短信等方式，100%通知到考生，实时监看考试确认参加情况，保障到场率；
                    分布式可无限弹性扩充系统，保证十万人同时在线考试，安全稳定，超强并发。
                  </ul>
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section2" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-2-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >02<img src="@/static/images/text-line-2.png" /></span
                  ><span>企业社招考试</span>
                </div>
                <div class="font-14">
                  轻松发布笔试试卷，多种方式通知候选人，支持PC、手机端参加笔试答题；
                  HR将候选人的试卷报告链接分享给负责人评阅试卷，快速收集笔试结果；
                  友好的阅卷界面、一键评分，填写评语，自动保存评分结果；
                  HR实时查看笔试成绩和评语，优化招聘全流程，快速锁定优秀人才。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section3" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-3-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >03<img src="@/static/images/text-line-1.png" /></span
                  ><span>员工晋升考核</span>
                </div>
                <div class="font-14">
                  低成本高效率完成内部员工晋升、胜任力达标能力测试、素质测评；
                  无纸化考试，无需打印试卷、安排地点，节约线下内部考核成本；
                  统计分析考核结果，掌握员工作答情况；
                  随时按需组织考试，让员工晋升考核更简单、有效。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section4" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-4-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >04<img src="@/static/images/text-line-2.png" /></span
                  ><span>培训认证考核</span>
                </div>
                <div class="font-14">
                  批量上传、随机组卷、智能阅卷、智能分析等功能从多方面为前期组织考试节省大量的成本；
                  考前人脸身份核验，权威数据确保本人考试；
                  智能判分系统，考后直出成绩及排行榜等信息；
                  对严肃正式的证书认证考试场景给予专业的技术支持，确保线上考试的公平、公正，促进人员甄别的速率提升
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section5" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect5"
                  style="width: 300px; left: 88px"
                  src="@/static/images/sence-5-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div
                  class="product-desc__title center"
                  style="margin-top: -15px"
                >
                  <span class="num"
                    >05<img src="@/static/images/text-line-1.png" /></span
                  ><span>高校招生测评</span>
                </div>
                <div class="font-14">
                  学校招生统一专业能力考试，更稳定、更安全；
                  基于AI的智能在线监考技术，通过音频+视频的方式对考试过程进行全面监控，保证线上考试的信效度；
                  远程视频面试选拔，面试流畅无卡顿；
                  已经获得国家信息系统安全等级保护三级认证，确保面试数据安全。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section6" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  style="width: 260px; left: 120px; height: inherit"
                  src="@/static/images/sence-6-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div
                  class="product-desc__title center"
                  style="margin-top: 10px"
                >
                  <span class="num"
                    >06<img src="@/static/images/text-line-2.png" /></span
                  ><span>随堂练习检测</span>
                </div>
                <div class="font-14">
                  学生随堂参加测试，考后查看题目解析，提升能力；
                  固定试题、随机试题、灵活的组卷方式；
                  大批量试题快速导入，音视频批量上传，更高效率；
                  可与学校管理系统对接，实现考试数据同步更新。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section7" class="section animate-box">
        <div class="text-box w-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect5"
                  style="width: 360px; left: 60px; height: inherit"
                  src="@/static/images/sence-7-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >07<img src="@/static/images/text-line-1.png" /></span
                  ><span>专业知识竞赛</span>
                </div>
                <div class="font-14">
                  提供专业知识竞赛平台，比赛页面专属定制化；
                  内置报名、组队、闯关等功能 ；
                  支持自动化判分，排名，支持数据、模型可视化；
                  支持在线编码，运行生成模型结果。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="section8" class="section animate-box">
        <div class="text-box b-box">
          <div class="paradigm_page_bg_white intro-card paradigm_page_bg cn">
            <div class="intro-card__right">
              <div class="big paradigm_sketch polygon">
                <textBg></textBg>
                <img
                  class="product-desc__sketch effect effect2"
                  src="@/static/images/sence-8-map.png"
                />
              </div>
            </div>
            <div class="intro-card__left">
              <div class="product-desc cn">
                <div class="product-desc__title center">
                  <span class="num"
                    >08<img src="@/static/images/text-line-2.png" /></span
                  ><span>海量题库刷题</span>
                </div>
                <div class="font-14">
                  为用户提供全面的技能提升练习平台；
                  碎片化时间，记录你的学习足迹，让进步看的见；
                  学员按知识点分类刷题，随机抽题，进阶学习；
                  十万专业题目，支持10大题型，海量题库使用。
                </div>
                <div class="center">
                  <a @click="goTest" class="btn" href="javascript:void(0)"
                    >产品试用</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exam-footer w-box">
      <div class="text-box">
        <div class="title">赛码优势</div>
        <div class="subtitle">领先技术和专业服务助您轻松实现各类业务场景</div>

        <div class="swiper">
          <div class="list">
            <div class="inner">
              <div class="top">
                <div class="circle"><i class="iconfont iconmianshi"></i></div>
              </div>
              <div class="middle">产品研发完善</div>
              <div class="font-14">
                产品功能强大，定制功能开发及时<br />
                全流程在线高效实施，<br />满足各种在线考试/面试需求
              </div>
            </div>
          </div>
          <div class="list">
            <div class="inner">
              <div class="top">
                <div class="circle"><i class="iconfont iconhuojian1"></i></div>
              </div>
              <div class="middle">系统高并发稳定</div>
              <div class="font-14">
                安全稳定，高效的运维保障体系<br />
                支持10万人高并发，<br />系统支撑了810+万人次笔试
              </div>
            </div>
          </div>
          <div class="list">
            <div class="inner">
              <div class="top">
                <div class="circle"><i class="iconfont iconmingdan"></i></div>
              </div>
              <div class="middle">试题研发专业</div>
              <div class="font-14">
                专业出题团队，<br />高效打造定制化题目，信效度高<br />
                原创保障，严把质量，<br />目前题库累积试题63+万道
              </div>
            </div>
          </div>
          <div class="list">
            <div class="inner">
              <div class="top">
                <div class="circle"><i class="iconfont iconjiankong1"></i></div>
              </div>
              <div class="middle">管家服务贴心</div>
              <div class="font-14">
                专注线上技术，也注重线下服务<br />
                快速响应客户需求，<br />提供优质的运营服务
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <examFooter></examFooter>
    <us-pc-dialog
      :dialogVisible="isPcDialogShow"
      @cancel="isPcDialogShow = false"
    />
  </div>
</template>

<script>
import bannerControl from '@/components/scene/banner.vue'
import textBg from '@/components/product/exam/text-bg.vue'
import examFooter from '@/components/product/exam/footer.vue'

export default {
  components: {
    bannerControl,
    textBg,
    examFooter,
  },
  data() {
    return { isMobile: false, isPcDialogShow: false }
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    this.toPage()
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val != oldVal) {
          console.log(val, 'val')
          this.toPage()
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    toPage() {
      let toPage = this.$route.query.to
      if (toPage) {
        window.scrollTo(0, document.getElementById(toPage).offsetTop)
      } else {
        window.scrollTo(0, 0)
      }
    },
    goTest() {
      if (this.isMobile) {
        this.isPcDialogShow = true
      } else {
        this.$bus.emit('compRegisterChoose')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.section {
  overflow-x: hidden;
}
.b-box {
  background: #f7f8fd url('/static/images/bbg.png') repeat-x;
}
.w-box {
  background: #fff url('/static/images/wbg.png') repeat-x;
}
.intro-card {
  display: flex;
  justify-content: center;
  padding: 70px 20px 60px;
  min-height: 550px;
  box-sizing: border-box;
  width: 1200px;
  margin: 0px auto;
  display: flex;
  .intro-card__left {
    width: 700px;
    .product-desc {
      width: 100%;
      padding-right: 30px;
      text-align: left;
      a {
        margin-top: 70px;
      }
      .product-desc__title {
        margin: 20px 0 40px;
        font-size: 36px;
        color: #000000;
        font-weight: 300;
        .num {
          font-size: 60px;
          font-weight: bold;
          font-family: Arial;
          position: relative;
          top: 8px;
          margin: 0px 10px 0px 0px;
          img {
            position: absolute;
            top: 50%;
            right: 0px;
            margin-top: -3px;
            left: -5%;
            width: 110%;
          }
        }
      }
      .product-desc__num {
        position: relative;
        margin-right: 15px;
        top: 10px;
        vertical-align: bottom;
      }
    }
  }
  .intro-card__right {
    width: 500px;
  }
}
.paradigm_sketch {
  position: relative;
  .effect {
    position: absolute;
    top: 50px;
    left: 58px;
    z-index: 9;
    width: 400px;
  }
  .effect2 {
    width: 300px;
    left: 117px;
    top: 100px;
  }
  .effect5 {
    width: inherit;
    height: 300px;
    left: 120px;
    top: 120px;
  }
}
.exam-footer {
  padding: 40px 0px 80px;
  .text-box {
    max-width: 1200px;
    margin: 0px auto;
    font-weight: 300;
  }
  .title {
    text-align: center;
    font-size: 30px;
  }
  .subtitle {
    padding: 20px 0px;
    text-align: center;
  }
  ul {
    display: flex;
    margin: 20px auto;
    li {
      width: 30%;
      text-align: center;
      &:nth-child(2) {
        width: 40%;
        padding: 0px 3%;
      }
      .text {
        padding: 10px 0px;
        font-weight: 300;
        font-size: 20px;
      }
      .info {
        text-align: left;
        font-size: 14px;
        line-height: 25px;
        font-weight: 300;
      }
    }
  }
}
.swiper {
  height: 100%;
  width: 1200px;
  display: flex;
  padding-top: 20px;
  .list {
    text-align: center;
    color: #333;
    min-height: 400px;
    display: inline-flex;
    width: 25%;
    .inner {
      width: 90%;
      margin: 0px auto;
      background-color: #fff;
      background-position: center;
      background-size: cover;
      border: 1px solid #eee;

      &:hover {
        background: #efefef;
      }

      .top {
        padding: 40px 20px 0px;
        .circle {
          background: url('~@/static/images/interview-3-bg.png') no-repeat center
            center;
          width: 124px;
          height: 124px;
          text-align: center;
          padding: 45px 20px 0px;
          margin: 0px auto;
          i {
            font-size: 35px;
            color: #fff;
          }
        }
      }
      .middle {
        padding: 30px 0px 0px;
        font-size: 24px;
      }
      .font-14 {
        padding: 10px 14px;
      }
    }
  }
}
.exam-mobile-lists {
  .section {
    .intro-card {
      width: initial;
      display: grid;
      padding: 0px 20px;
      margin-top: -20px;
      .intro-card__left {
        float: left;
        width: initial;
        padding: 0px;
        .product-desc {
          padding: 0px;
          a {
            margin: 20px 0;
          }
          .center {
            text-align: center;
          }
          .product-desc__title {
            margin: -40px 0 20px 0;
            font-size: 28px;

            .num {
              font-size: 44px;
              top: 4px;
            }
          }
        }
      }
      .intro-card__right {
        float: left;
        width: 100%;
        .paradigm_sketch {
          transform: scale(0.7);
          margin-left: -70px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .banner {
    .title {
      font-size: 20px;
    }
  }

  .exam-footer {
    .text-box {
      .title {
        padding: 0;
      }
      .subtitle {
        font-size: 15px;
        margin-top: -12px;
      }
      .swiper {
        width: initial;
        display: initial;
        .list {
          display: block;
          width: 100%;
          margin-bottom: 30px;
          min-height: initial;
          .inner {
            width: 100%;
            .top {
              padding: 30px 0 0;
            }
            .middle {
              padding: 20px 0 0;
            }
            .font-14 {
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .exam-mobile-lists {
    .intro-card__right {
      .paradigm_sketch {
        margin-left: 0px !important;
      }
    }
    .intro-card__left {
      width: 500px !important;
      .product-desc {
        text-align: center;
      }
    }
  }

  .exam-footer {
    padding: 30px 140px !important;
    .text-box {
      .title {
        padding: 0;
      }
      .subtitle {
        font-size: 15px;
        margin-top: -12px;
      }
      .swiper {
        width: initial;
        display: initial;
        .list {
          display: block;
          width: 100%;
          margin-bottom: 30px;
          min-height: initial;
          .inner {
            width: 100%;
            .top {
              padding: 30px 0 0;
            }
            .middle {
              padding: 20px 0 0;
            }
            .font-14 {
              padding-bottom: 20px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/scene/index.vue